import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, UserLogin } from 'ngx-sds-login';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ParametersDTO } from 'src/app/infraestructure/interfaces/parameters/ParametersDTO';
import { ConsultaSolicitudesDisponiblesDTO } from 'src/app/infraestructure/interfaces/referente/ConsultaSolicitudesDisponiblesDTO';
import { SolicitudesPendientesAprobacionDTO } from 'src/app/infraestructure/interfaces/referente/SolicitudPendienteAprobacionDTO';
import { CancelarSolicitudServicioI } from 'src/app/infraestructure/models/cancelarSolicitud.interface';
import { SolicitudCambiarEstadoI } from 'src/app/infraestructure/models/solicitudCambiarEstado.interface';
import { ParametricListsService } from 'src/app/infraestructure/services/parametric-lists/parametric-lists.service';
import { ReferentApiService } from 'src/app/infraestructure/services/referent/referent-api.service';
import { SwalToast } from 'src/app/infraestructure/utils/toast/SwalToast';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cancelar-solicitud-servicio',
  templateUrl: './cancelar-solicitud-servicio.component.html',
  styleUrls: ['./cancelar-solicitud-servicio.component.scss']
})
export class CancelarSolicitudServicioComponent implements OnInit, OnChanges {

  @Output() cancel = new EventEmitter<string>();
  @Output() reloadTable = new EventEmitter<boolean>();

  @Input() codeSolicitud: number = 0;
  @Input() solicitudSeleccionada = {} as SolicitudesPendientesAprobacionDTO;
  @Input() solicitudDisponibleSeleccionada = {} as ConsultaSolicitudesDisponiblesDTO;


  $parametricList: ParametersDTO = new ParametersDTO();
  private $topSubcription = new Subject<void>();
  user$: Observable<UserLogin>;

  dataCancelar = {} as CancelarSolicitudServicioI;
  dataSolicitud = {} as SolicitudCambiarEstadoI;

  dataTableSolicitud: any;
  rolId: number = 0;
  userId: number = 0;

  constructor(private _listSrv: ParametricListsService,
    private referentApiSrv: ReferentApiService,
    private store: Store<AppState>,) {
    this.user$ = this.store.select(state => state.user);
  }

  ngOnInit(): void {
    this._listSrv.getDataLists('TIP_MOTIVOS_CANCELACION')
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code == 200) this.$parametricList.typeCancellationsList = res.data;
      });
      this.user$.pipe(
        takeUntil(this.$topSubcription)
      )
      .subscribe(user => {
        if (user.id > 0) {
          this.userId = user.id;
          this.rolId = user.rolId;

        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['solicitudSeleccionada'] && this.solicitudSeleccionada.id) {
      this.setDataTable();
    } else if (changes['solicitudDisponibleSeleccionada'] && this.solicitudDisponibleSeleccionada.id) {
      this.setDataTable2();
    }
  }

  setDataTable() {
    this.dataTableSolicitud = {
      id: this.solicitudSeleccionada.id,
      referenteSolicitud: this.solicitudSeleccionada.vcNombreReferente,
      fechaSolicitud: this.solicitudSeleccionada.dtFechaSolicitud,
      nombreDirectivo: this.solicitudSeleccionada.vcNombreDirectivo,
      motivo: ''
    }
  }

  setDataTable2() {
    this.dataTableSolicitud = {
      id: this.solicitudDisponibleSeleccionada.id,
      vcTrayecto: this.solicitudDisponibleSeleccionada.vcTrayecto,
      vcLugarSalida: this.solicitudDisponibleSeleccionada.vcLugarSalida,
      vcLugarDestino: this.solicitudDisponibleSeleccionada.vcLugarDestino,
      dtHoraSalida: this.solicitudDisponibleSeleccionada.dtHoraSalida,
      dtHoraRegreso: this.solicitudDisponibleSeleccionada.dtHoraRegreso,
      dtFechaSolicitud: this.solicitudDisponibleSeleccionada.dtFechaSolicitud,
      dtFechaPrestacionServicio: this.solicitudDisponibleSeleccionada.dtFechaPrestacionServicio,
      vcEstado: this.solicitudDisponibleSeleccionada.vcEstado,
      motivo: ''
    }
  }

  actionSucces(title: string, message: string) {
    Swal.fire({
      position: "center",
      icon: "success",
      title: `${title}`,
      text: `${message}`,
      showConfirmButton: true,
      confirmButtonColor: "#004884",
      confirmButtonText: "ACEPTAR",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        this.reloadTable.emit(true);
        this.onCancel();
      }
    });
  }

  actionWarning(message: string, action: string) {
    Swal.fire({
      position: "center",
      icon: "warning",
      title: "<h5 style='color:#f8bb86'>" + 'Advertencia' + "</h5>",
      text: `${message}`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: "#2BA3BF",
      confirmButtonText: "ACEPTAR",
      cancelButtonText: 'CANCELAR'
    }).then((result) => {
      if (result.isConfirmed) {
        if (action === 'cerrar') return this.onCancel();
        if (action === 'enviar') return this.onEnviar();
      }
    });
  }

  onSelect() {
    this.$parametricList.typeCancellationsList.filter((item : any) => {
      if (item.idParametroDetalle == this.dataCancelar.MotivoCancelacionId) return this.dataTableSolicitud.motivo = item.vcNombre;
    });
  }

  onEnviar() {
    this.dataSolicitud.accion = 'CANCELAR';
    this.dataSolicitud.rolId = this.rolId;
    this.dataSolicitud.usuarioId = this.userId;
    this.dataSolicitud.solicitudId = this.codeSolicitud;
    this.dataSolicitud.datos = this.dataCancelar;

    this.referentApiSrv.putSolicitudCambiarestado(this.dataSolicitud)
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code === 200) {
          this.actionSucces('Cancelación exitosa', 'Cancelación de la solicitud de servicio exitosa');
        } else {
          const messages = res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n');
          
          Swal.fire({
            title: 'Errores',
            icon: 'error',
            html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
            showConfirmButton: true,
            confirmButtonColor: "#004884",
            confirmButtonText: "ACEPTAR",
          });
        }
      });
  }

  onCancel() {
    this.cancel.emit('close');
  }

}
